<!-- Upload-Button -->
@if (!readonly) {
	<div class="upload-section mb-3">
		<label class="btn btn-outline-primary btn-sm" [class.disabled]="isUploading()">
			<i class="bi bi-paperclip me-1"></i>
			@if (isUploading()) {
				Wird hochgeladen...
			} @else {
				Datei hinzufügen
			}
			<input
				type="file"
				[accept]="getAcceptString()"
				(change)="onFileSelected($event)"
				[disabled]="isUploading()"
				multiple
				hidden
			/>
		</label>
		<small class="text-muted ms-2">JPG, PNG, BMP, TIF, PDF (max. 10 MB)</small>
	</div>
}

<!-- Loading -->
@if (isLoading()) {
	<div class="text-center py-3">
		<div class="spinner-border spinner-border-sm text-secondary" role="status">
			<span class="visually-hidden">Lädt...</span>
		</div>
	</div>
}

<!-- Attachment-Grid -->
@if (!isLoading()) {
	@if (attachments().length === 0) {
		<div class="text-muted small">
			Keine Anhänge vorhanden.
		</div>
	} @else {
		<div class="attachments-grid">
			@for (attachment of attachments(); track attachment.name) {
				<div
					class="attachment-item"
					[class.loading]="attachment.loading"
					(click)="onAttachmentClick(attachment)"
					[title]="attachment.name + ' (' + formatFileSize(attachment.size) + ')'"
				>
					<!-- Thumbnail/Icon -->
					<div class="attachment-preview">
						@if (isImage(attachment.contentType)) {
							@if (attachment.thumbnailUrl) {
								<img [src]="attachment.thumbnailUrl" [alt]="attachment.name" />
							} @else if (attachment.error) {
								<i class="bi bi-image-fill text-danger"></i>
							} @else {
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="visually-hidden">Lädt...</span>
								</div>
							}
						} @else if (isPdf(attachment.contentType)) {
							<i class="bi bi-file-pdf-fill"></i>
						} @else {
							<i class="bi bi-file-earmark"></i>
						}
						@if (attachment.loading) {
							<div class="loading-overlay">
								<div class="spinner-border spinner-border-sm text-light" role="status"></div>
							</div>
						}
					</div>

					<!-- Dateiname + Größe -->
					<div class="attachment-info">
						<div class="attachment-name">{{ attachment.name }}</div>
						<div class="attachment-size">{{ formatFileSize(attachment.size) }}</div>
					</div>

					<!-- Löschen-Button -->
					@if (!readonly) {
						<button
							class="btn btn-link btn-sm delete-btn p-0"
							(click)="onDelete(attachment, $event)"
							title="Löschen"
						>
							<i class="bi bi-trash text-danger"></i>
						</button>
					}
				</div>
			}
		</div>
	}
}
